import type { GameResult } from "../types";

/**
 * Challenge a friend: the missing viral half of Signal or Noise. The existing share sends
 * your grid; the challenge sends a taunt plus a deep link that drops the recipient straight
 * into today's game (the app opens the overlay when the hash asks for it). Every link keeps
 * the referral loop (?r=) the site already captures.
 * House style: no em dashes or en dashes anywhere in copy.
 */

/** The deep link that opens the game directly on arrival. `anonId` is the device id before
 *  sign-in and "" after it: an account uid never rides a link, so the r= is simply left off. */
export function challengeUrl(anonId: string, origin = "https://insnip.com"): string {
  const ref = anonId ? `?r=${encodeURIComponent(anonId)}` : "";
  return `${origin}/${ref}#game`;
}

/** The challenge message: spoiler-free score plus the direct game link. */
export function challengeText(result: GameResult, anonId: string, origin?: string): string {
  const scoreLine =
    result.correct === result.total
      ? `I just got a perfect ${result.correct}/${result.total} on today's Signal or Noise.`
      : `I scored ${result.correct}/${result.total} on today's Signal or Noise.`;
  return (
    `${scoreLine}\n` +
    `${result.shareGrid}\n` +
    `Think you can beat me? ${challengeUrl(anonId, origin)}`
  );
}

/** Whether a location hash asks to open the game (the challenge landing). */
export function wantsGameFromHash(hash: string | undefined | null): boolean {
  if (!hash) return false;
  return /^#game(\b|=|$)/i.test(hash.trim());
}
